module.exports = __webpack_public_path__ + "static/media/vihara.41d05acb.svg";